import type { Ref } from 'vue';
import { defineStore } from 'pinia';
import {
  computed,
} from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';
import {
  isString,
} from '@utils/guards';

const useFrontendLocalesStore = defineStore('frontend-locales', () => {
  const translationsMaps: Record<symbol, Ref<Record<string, string>>> = {};

  function addTranslationsMap(group: symbol, keys: () => Ref<ITranslationsKeyMap>): void {
    if (translationsMaps[group]) {
      throw new Error(`Translation group ${String(group)} already exists`);
    }

    translationsMaps[group] = computed(() => {
      const result: Record<string, string> = {};

      const fillCodes = (map: ITranslationsKeyMap, joinKey = ''): void => {
        for (const key of Object.keys(map)) {
          const value = map[key];
          const translationKey = `${joinKey}${key}`;

          if (isString(value)) {
            if (result[value]) {
              console.error(`Shortcode ${value} for translation group ${String(group)} already exists`);
            } else {
              result[value] = translationKey;
            }
          } else {
            fillCodes(value, `${translationKey}.`);
          }
        }
      };

      fillCodes(keys().value);

      return result;
    });
  }

  function getTPath(groupKey: symbol, shortCode: string): string {
    const map = translationsMaps[groupKey];

    if (!map) {
      console.error(`There is no group key: ${String(groupKey)}`);
      return shortCode;
    }

    const localePath = map.value[shortCode];

    if (!localePath) {
      console.error(`There is no locale-path for short-code: ${shortCode} in group: ${String(groupKey)}`);
      return shortCode;
    }

    return localePath;
  }

  function getTranslationsMaps(): Record<symbol, Ref<Record<string, string>>> {
    return translationsMaps;
  }

  return {
    getTranslationsMaps,
    getTPath,
    addTranslationsMap,
  };
});

export default useFrontendLocalesStore;
